var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "white",
    stroke: "#AE97FF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0001 5.75C20.811 6.06667 21.5751 6.47679 22.2792 6.96712C25.1327 8.95439 27.0001 12.2592 27.0001 16.0001C27.0001 22.0753 22.0753 27.0001 16.0001 27.0001C12.2592 27.0001 8.95439 25.1327 6.96712 22.2792C6.47679 21.5751 6.06667 20.811 5.75 20.0001C5.75 20.0001 6.69065 20.3011 8.13403 20.3777C10.4113 20.4984 13.9398 20.0604 17.0001 17.0001C20.0604 13.9398 20.4984 10.4113 20.3777 8.13403C20.3011 6.69065 20.0001 5.75 20.0001 5.75ZM18.4143 18.4143C21.3287 15.4999 22.2194 12.1936 22.3703 9.64186C23.9961 11.271 25.0001 13.5194 25.0001 16.0001C25.0001 20.9707 20.9707 25.0001 16.0001 25.0001C13.5194 25.0001 11.271 23.9961 9.64186 22.3703C12.1936 22.2194 15.4999 21.3287 18.4143 18.4143ZM11.0001 7.41434L12.4143 8.82857L11.0001 10.2428L12.4143 11.657L13.8285 10.2428L15.2427 11.657L16.6569 10.2428L15.2428 8.82857L16.657 7.41434L15.2428 6.00012L13.8285 7.41435L12.4143 6.00012L11.0001 7.41434ZM10 17.0001C11.1046 17.0001 12 16.1047 12 15.0001C12 13.8956 11.1046 13.0001 10 13.0001C8.89543 13.0001 8 13.8956 8 15.0001C8 16.1047 8.89543 17.0001 10 17.0001Z",
    fill: "#220C4A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.b2dc9f0de0bd0e922a9f00661c6d9a01.svg";
export { ForwardRef as ReactComponent };